import { ShieldCheck } from 'lucide-react';
import { CANCELLATION_POLICIES } from '../../utils/policies';
import { CATEGORIES } from '../../lib/categories';
import { SpecialtyPicker } from './SpecialtyPicker';

export function CategoriesStep({ form, setForm, onCategoryToggle }) {
  return (
    <div className="space-y-8 animate-fadeIn">
      {/* Categories */}
      <div>
        <h2 className="font-heading text-2xl font-medium text-[#1A1A1A] mb-2">What services do you offer?</h2>
        <p className="text-stone-500">Select all categories that apply to your services.</p>
      </div>

      <div className="grid grid-cols-2 gap-3" data-testid="categories-grid">
        {CATEGORIES.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryToggle(category.id)}
            className={`p-4 rounded-lg border text-left transition-colors ${
              form.categories.includes(category.id)
                ? 'border-[#D4AF37] bg-[#F9F6F0]'
                : 'border-[#E6E4DD] hover:border-[#D4AF37]'
            }`}
            data-testid={`category-${category.id}`}
          >
            <span className="font-medium text-[#1A1A1A]">{category.name}</span>
          </button>
        ))}
      </div>

      {form.categories.length === 0 && (
        <p className="text-sm text-red-500">Please select at least one category</p>
      )}

      {form.categories.length > 0 && (
        <div className="pt-2">
          <h3 className="font-heading text-lg font-medium text-[#1A1A1A] mb-1">Your specialties</h3>
          <p className="text-stone-500 text-sm mb-4">Optional. Tick what you are known for so clients searching for it can find you.</p>
          <SpecialtyPicker
            categories={form.categories}
            selected={form.specialties || []}
            onChange={(specialties) => setForm((prev) => ({ ...prev, specialties }))}
            testId="onboarding-specialty-picker"
          />
        </div>
      )}

      {/* Cancellation Policy */}
      <div className="pt-6 border-t border-[#E6E4DD]">
        <h3 className="font-heading text-xl font-medium text-[#1A1A1A] mb-2 flex items-center gap-2">
          <ShieldCheck className="h-5 w-5 text-[#D4AF37]" />
          Cancellation Policy
        </h3>
        <p className="text-stone-500 text-sm mb-4">Choose how cancellations are handled. This is shown to clients before they book.</p>

        <div className="space-y-3">
          {CANCELLATION_POLICIES.map(policy => (
            <button
              key={policy.id}
              onClick={() => setForm(prev => ({ ...prev, cancellation_policy: policy.id }))}
              className={`w-full text-left p-4 rounded-lg border transition-colors ${
                form.cancellation_policy === policy.id
                  ? 'border-[#D4AF37] bg-[#F9F6F0]'
                  : 'border-[#E6E4DD] hover:border-[#D4AF37]'
              }`}
              data-testid={`onboard-policy-${policy.id}`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-4 h-4 rounded-full border-2 mt-0.5 flex-shrink-0 ${
                  form.cancellation_policy === policy.id ? 'border-[#D4AF37] bg-[#D4AF37]' : 'border-stone-300'
                }`}>
                  {form.cancellation_policy === policy.id && (
                    <div className="w-full h-full rounded-full flex items-center justify-center">
                      <div className="w-1.5 h-1.5 rounded-full bg-white" />
                    </div>
                  )}
                </div>
                <div>
                  <p className="font-medium text-[#1A1A1A] text-sm">{policy.label}</p>
                  <p className="text-xs text-stone-500 mt-0.5">{policy.summary}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
